import React from 'react';
import Freezer from './component';

export default React.memo(Freezer);
